var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['user-layout', _vm.device],attrs:{"id":"userLayout"}},[_c('div',{staticClass:"user-layout-container"},[_c('div',{staticClass:"user-layout-header"},[(_vm.$config.banner)?_c('img',{staticClass:"user-layout-logo",style:({
          width: _vm.$config.theme['@banner-width'],
          height: _vm.$config.theme['@banner-height']
        }),attrs:{"src":_vm.$config.banner,"alt":"logo"}}):_vm._e()]),_c('route-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }